import { Expose } from 'class-transformer';
import { Model } from './model';
import { AverageWithRate } from '../../interface';

export class WhiteLabelAverageSession extends Model {
  @Expose() minutesAverageData: AverageWithRate;
  @Expose() pagesData: AverageWithRate;
  @Expose() sessionData: AverageWithRate;
}
